import { AccountMultipleMinusOutlineIcon } from './AccountMultipleMinusOutlineIcon';

/**
 * author: Google
 * id 45C692AD-F1E8-404C-BED2-9FD58F0690CD
 * name account-multiple-minus-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-multiple-minus-outline.svg
 * tags
 * - Account / User 
 */
export const AccountsMinusOutlineIcon = AccountMultipleMinusOutlineIcon;
export default AccountsMinusOutlineIcon